<template>
  <div>
    <div class="mt-2" v-if=" msgErro.length >0 && $v.$error">
      <v-alert type="error" dense class="subtitle-2 font-weight-regular">
        <div class="p-1" v-if="msgErro.length > 0">
          <div  v-for="erro in msgErro" :key="erro">
            <span v-html="erro"></span> 
          </div>
        </div>
        <div v-else>>
          {{ msgErro }}
        </div>
      </v-alert>
    </div>
    <v-container>
      <v-row>
        <v-col cols="12" md="2">
          <v-text-field
            type="text"
            label="Ano Letivo*"
            filled
            class="filled-error"
            id="aaletivo" 
            :error=" ($v.aaletivo.required === false ) && $v.$dirty === true ? true : false"
            :error-messages=" ($v.aaletivo.required === false ) && $v.$dirty === true ? messages.required : ($v.aaletivo.minLength === false ) && $v.$dirty === true  ? messages.minLength.replace(':min', 4) : '' "
            background-color="white"
            hide-details="auto"
            v-model="aaletivo"
            v-mask="'####'"
            :disabled=carregandoDadosTabela
            @keypress.enter="procurar()"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field 
            type="text"
            :label="tipoPesquisa == 'Matrícula' ? 'Matrícula*' : 'Nome*'"
            filled
            class="filled-error"
            id="textoProcurado"
            :error=" ($v.textoProcurado.required === false ) && $v.$dirty === true ? true : false"
            :error-messages=" ($v.textoProcurado.required === false ) && $v.$dirty === true ? messages.required : ($v.textoProcurado.textoProcuradoRule === false ) && $v.$dirty === true  ? messages.minLength.replace(':min', 7) : '' "
            background-color="white"
            hide-details="auto"
            v-mask="tipoPesquisa == 'Matrícula' ? 'm######' : customTokens"
            v-model="textoProcurado"
            :disabled=carregandoDadosTabela
            @keypress.enter="procurar()"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-select :items="items"
            label="Pesquisar por"
            filled
            background-color="white"
            :disabled=carregandoDadosTabela
            v-model=tipoPesquisa
            @change="limparCampo()">
          </v-select>
        </v-col>
        <v-col cols="1">
          <v-btn :disabled=carregandoDadosTabela class="mt-n15 mt-md-3" depressed color="primary" @click="procurar()"> OK </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-n7">
        <v-col md="12">
          <v-data-table
            :headers="headers"
            :items="professores"
            :items-per-page="15"
            class="elevation-1"
            :loading=carregandoDadosTabela
            loading-text="Carregando dados. Por favor espere."
            :footer-props="{
                  'items-per-page-text':'Itens por página',
                  'items-per-page-all-text':  'Todos',
                  'pageText': '{0}-{1} de {2}'
            }"
          >
          <template slot="no-data">
            <span style="text-align:center">Nenhum dado para mostrar.</span>
          </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import distribuicaoOnline from "../../api/distribuicaoOnline";
import { mapGetters } from 'vuex'
import { mask } from "vue-the-mask"
import { required, minLength } from 'vuelidate/lib/validators'
import  messages  from '../../utils/messages'

const textoProcuradoRule = (value, vm) => { return (vm.tipoPesquisa == 'Matrícula') ? value.length >= 7 : true ; };

export default {
  name: "relatorio-email",
  directives: { mask },

  data() {
    return {
      aaletivo: null,
      textoProcurado: '',
      items: ['Matrícula', 'Nome'],
      tipoPesquisa: 'Matrícula',
      carregandoDadosTabela: false,
      msgErro: [],

      headers: [
        {
          text: "Matrícula",
          align: "start",
          sortable: false,
          value: "matric",
        },
        { text: "Nome", value: "nom" },
        { text: "E-mail", value: "mail" },
      ],
      professores: [],

      customTokens: {
            mask: 'P'.repeat(100),
            tokens: {
                'P': {
                    pattern: /[0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ -_]+$/,
                    transform: function(v) {
                        return v;
                    }
                }
            }
        },
      messages: messages,
    };
  },

  validations: {
      aaletivo: {required, minLength: minLength(4)},
      textoProcurado: { required, textoProcuradoRule}
  },

  async created() {
    this.aaletivo = this.getAnoLetivo;
  },

  methods: {
    limparCampo() {
      this.$nextTick(() => this.textoProcurado = '')
    },
    async procurar() {
      this.$v.$touch()
      if(this.$v.$invalid){
        this.msgErro = ['Preencha os campos corretamente']

        return;
      };

      this.professores = []

      this.carregandoDadosTabela = true;

      let params = this.tipoPesquisa == 'Matrícula' ? {cdmatric: this.textoProcurado} : {nome: this.textoProcurado}

      try {
        const { data } = await distribuicaoOnline.listar({ aaletivo: this.aaletivo, ...params});
  
        if (data) {
          data.professores.forEach( professor => {
            this.professores.push({ 
              'matric': professor.cdmatric,
              'nom': professor.nmfuncion,
              'mail': professor.edemail ? professor.edemail : 'Sem e-mail cadastrado'
            });
          });
        }
      }
      catch(e) {
        this.carregandoDadosTabela = false;
      }

      this.carregandoDadosTabela = false;
    },
  },

  computed: {
    ...mapGetters(['getAnoLetivo']),
  }
};
</script>

<style scoped>
</style>